import { render, staticRenderFns } from "./DashMenu.vue?vue&type=template&id=330673e0&scoped=true&"
import script from "./DashMenu.vue?vue&type=script&lang=js&"
export * from "./DashMenu.vue?vue&type=script&lang=js&"
import style0 from "./DashMenu.vue?vue&type=style&index=0&id=330673e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330673e0",
  null
  
)

export default component.exports